import { render } from "./PaymentConfirmationPage.vue?vue&type=template&id=6802366f"
import script from "./PaymentConfirmationPage.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__